export class InputFieldModel {

    public fieldBlock: string;
    public fieldType: string;
    public fieldName: string;
    public fieldLabel: string;
    public inputSelect: Array<any>;
    public required: boolean;
    public validationType: string;

    constructor(obj?: any) {
        this.fieldBlock = obj && obj.fieldBlock || '';
        this.fieldType = obj && obj.fieldType || '';
        this.fieldName = obj && obj.fieldName || '';
        this.fieldLabel = obj && obj.fiealdLabel || '';
        this.inputSelect = obj && obj.inputSelect || new Array();
        this.required = obj && obj.required || false;
        this.validationType = obj && obj.validationType || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/input-field.model.ts